import { enumsCashback, formatDate } from '@itarget/shared'
import { useTranslation } from './useTranslation'

const {
  OPERATIONS: {
    TRANSACTION_TYPE: { CREDIT, DEBIT },
  },
  TRANSACTION: {
    TRANSACTION_STATUS: { PENDING, CONFIRMED, CANCELED },
  },
  PRODUCTS_CAMPINGS: {
    MODEL_TYPE: { CASHBACK, POINTS },
  },
} = enumsCashback

export const useTransaction = () => {
  const translation = useTranslation()

  const getTransactionModalityLabel = (productCampaignModality) => {
    if (productCampaignModality === CASHBACK) return translation.cash
    if (productCampaignModality === POINTS) return translation.points
    return translation.notIdentified
  }
  const getTransactionStatusLabel = (transactionStatus) => {
    if (transactionStatus === PENDING) return translation.pending
    if (transactionStatus === CONFIRMED) return translation.confirmed
    if (transactionStatus === CANCELED) return translation.canceled
    return translation.notIdentified
  }
  const getTransactionTypeLabel = (transactionType) => {
    if (transactionType === CREDIT) return translation.credit
    if (transactionType === DEBIT) return translation.debit
    return translation.notIdentified
  }
  const getDataTransactionType = (transactionType) => {
    if (transactionType === CREDIT) return 'credit'
    if (transactionType === DEBIT) return 'debit'
    return 'notIdentified'
  }
  const getTransactionSymbol = (transactionType) => {
    if (transactionType === CREDIT) return '+ '
    if (transactionType === DEBIT) return '- '
    return ''
  }
  const getDate = (date) => {
    if (!date) return ''
    return formatDate.ptBr(date)
  }
  const getHour = (time) => {
    if (!time) return ''
    return formatDate.hour(time)
  }
  return {
    getTransactionModalityLabel,
    getTransactionStatusLabel,
    getTransactionTypeLabel,
    getDataTransactionType,
    getTransactionSymbol,
    getDate,
    getHour,
  }
}
